import React from 'react';
import { ExplorationPath } from '@models/feature-space';

import {
  ExplorationPathHeader,
  ExplorationPathJoinList,
} from '../../feature-descriptor/feature-exploration-path';
import { JoinDescriptionId } from '@models/feature-descriptor-domain';

export const FeatureExplorationPaths: React.FC<{
  explorationPaths: ExplorationPath[];
  selectedJoinIds: JoinDescriptionId[];
  setSelectedJoinIds: (ids: JoinDescriptionId[]) => void;
}> = ({ explorationPaths, selectedJoinIds, setSelectedJoinIds }) => {
  return (
    <>
      {explorationPaths.map((explorationPath, idx) => (
        <div key={idx} className="exploration-path">
          <ExplorationPathHeader
            explorationPath={explorationPath}
            explorationPathIndex={idx}
          />
          <div style={{ paddingLeft: '16px' }}>
            <ExplorationPathJoinList
              joins={explorationPath.joins}
              selectedJoinIds={selectedJoinIds}
              setSelectedJoinIds={setSelectedJoinIds}
            />
          </div>
        </div>
      ))}
    </>
  );
};
